import isNil from 'lodash/isNil'
import last from 'lodash/last'
import omitBy from 'lodash/omitBy'
import { parse, stringify } from 'querystringify'
import { baseUrl } from 'supporticon/utils/justgiving'

const mapParams = string => {
  if (typeof string !== 'string') return {}
  return parse(last(string.split('?')))
}

const stringifyParams = params => stringify(omitBy(params, isNil))

export const buildDonationUrl = (page, amount, reference, params = '') =>
  [
    `${baseUrl('link')}/v1/fundraisingpage/donate/pageId/${page.id}`,
    stringifyParams({
      amount,
      reference,
      ...mapParams(params)
    })
  ]
    .filter(Boolean)
    .join('?')
